import ModalView from "@modals/modalview/ModalView";
import styles from "./EditPhoneNumber.module.css";
import { usePhoneCredentials, useLoginModals } from "@hooks/login";

function EditPhoneNumber({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const { goToSendOtp } = useLoginModals();
  const {
    phoneNumber,
    countryCode,
    isPhoneComplete,
    updatePhoneNumber,
    updateCountryCode,
  } = usePhoneCredentials();

  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      <div className={styles.EditPhoneNumberContainer}>
        <div className={styles.editHeader}>
          <h2>Edit Phone Number</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            &times;
          </button>
        </div>
        <div>
          <select
            value={countryCode}
            className={styles.dial_code_select}
            onChange={(e) => updateCountryCode(e.target.value)}
          >
            <option value="+91">+91</option>
          </select>

          <input
            type="tel"
            className={styles.mobile_number_input}
            placeholder="Enter your mobile number"
            onChange={(e) => updatePhoneNumber(e.target.value)}
            value={phoneNumber}
            maxLength={10}
          />
        </div>
        <div>
          <button
            className={styles.nextButton}
            disabled={!isPhoneComplete}
            onClick={goToSendOtp}
          >
            NEXT
          </button>
        </div>
      </div>
    </ModalView>
  );
}

export default EditPhoneNumber;
